// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2-_z2","dragIcon":"SortableItem_dragIcon__9p5Hl","disabled":"SortableItem_disabled__uYWCm"};